import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyUsage = (
  data: IPropertyDetailsResponse
): string | null => {
  const usageImprovement = data?.improvements_list
    ?.filter(improvement => improvement.name === "Uso")
    .map(improvement => improvement.value)
    .join(", ");

  return usageImprovement || null;
};
